export const validateName = (name) => {
//no restriction on which characters are allowed; callers already enforce non-empty/min-length
return typeof name === 'string' && name.trim().length > 0;
}

export const validateEmail = (email) => {
    //validate email should be a valid email
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return false;
    }
    return true;
}

export const validatePhone = (phone) => {
    // validate phone: 6–15 digits (local part when used with country code)
    if (!/^[0-9]{6,15}$/.test(phone) || phone < 0) {
        return false;
    }
    return true;
}